export default "__VITE_ASSET__CExU2YLt__"